export const PRINTFUL_PRODUCT_TYPES_FIELDS_LIST: any = [
    {attribute: "name", label: "Name", cssClass: ''},
    {attribute: "type", label: "Type", cssClass: ''},
    {attribute: "key", label: "Key", cssClass: ''},
    {attribute: "total", label: "Total Products", cssClass: ''},
];


export const PRINTFUL_PRODUCT_TYPES_INPUT_FIELDS: any = [
    {attribute: "name", label: "Name", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "type", label: "Type", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "key", label: "Key", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "total", label: "Total Products", type: 'text', group: 'detail', cssClass: ''},
];
